module.exports = __webpack_public_path__ + "img/QuestionMarkOutlined.df17addc.svg";